import React, { Component } from 'react';
import "./home.css"
class Home extends Component {
  render() {
    // var divStyle = {
    //     color: 'white',
    //     background: "red",
    //     height:"auto",
    //     WebkitTransition: 'all', // note the capital 'W' here
    //     "margin-top":"110px"
        
    //   };
    return (
            <div className="Home"> 
               <div class="container">
                  <h2>Responsive Tables Using LI <small>Triggers on 767px</small></h2>
                  <ul class="responsive-table">
                    <li class="table-header">
                      <div class="col col-1">Job Id</div>
                      <div class="col col-2">Customer Name</div>
                      <div class="col col-3">Amount Due</div>
                      <div class="col col-4">Payment Status</div>
                    </li>
                    <li class="table-row">
                      <div class="col col-1" data-label="Job Id">42235</div>
                      <div class="col col-2" data-label="Customer Name">John Doe</div>
                      <div class="col col-3" data-label="Amount">$350</div>
                      <div class="col col-4" data-label="Payment Status">Pending</div>
                    </li>
                    <li class="table-row">
                      <div class="col col-1" data-label="Job Id">42442</div>
                      <div class="col col-2" data-label="Customer Name">Jennifer Smith</div>
                      <div class="col col-3" data-label="Amount">$220</div>
                      <div class="col col-4" data-label="Payment Status">Pending</div>
                    </li>
                    <li class="table-row">
                      <div class="col col-1" data-label="Job Id">42257</div>
                      <div class="col col-2" data-label="Customer Name">John Smith</div>
                      <div class="col col-3" data-label="Amount">$341</div>
                      <div class="col col-4" data-label="Payment Status">Pending</div>
                    </li>
                    <li class="table-row">
                      <div class="col col-1" data-label="Job Id">42311</div>
                      <div class="col col-2" data-label="Customer Name">John Carpenter</div>
                      <div class="col col-3" data-label="Amount">$115</div>
                      <div class="col col-4" data-label="Payment Status">Pending</div>
                    </li>
                  </ul>
                </div>
                <div className="title-head">
                              <b>   <i className="fas fa-money-bill-alt icon-link"></i> Payment </b> 
                             </div>
                             <div className="list-body">  
                             <div className="list-type4">
                                <ol>
                                  
                                    <li>
                                        <a href="#">    
                                            <table className="table">
                                              <tbody>
                                                    <tr>
                                                        <td>
                                                        <span className="dot">
                                                        <h3 className=" center-text"> C </h3>
                                                        </span>
                                                        </td>
                                                        <td> Chich chinye</td>
                                                        <td>KG 5</td>
                                                        <td>stroy book 1</td>
                                                        <td>₦ 50000</td>
                                                        <td>today</td>
                                                    </tr>
                                                </tbody>
                                            </table>      
                                        </a>
                                    </li>
                                    <li>
                                        <a href="#">    
                                        <table className="table">
                                          <tbody>
                                                <tr>
                                                    <td>
                                                    <span className="dot">
                                                      <h3 className=" center-text"> G </h3>
                                                    </span>
                                                    </td>
                                                    <td> Groege chinye</td>
                                                    <td>KG 5</td>
                                                    <td>Love stroy  1</td>
                                                    <td>₦ 1000</td>
                                                    <td>today</td>
                                                </tr>
                                              </tbody>
                                           </table>      
                                        </a>
                                    </li>
                                   
                                    
                                </ol>
                                  <div className="button-body">
                                  <a className="button is-success">
                                        <span>More</span>
                                        <span className="icon is-small">
                                        <i className="fas fa-arrow-circle-right"></i>
                                        </span>
                                    </a>   
                                 </div>
                                    
                                </div>
                             </div>
                             {/* * domready (c) Dustin Diaz 2014 - License MIT
                             * domready (c) Dustin Diaz 2014 - License MIT
                             * domready (c) Dustin Diaz 2014 - License MIT */}
       
           </div>     

    )

}





}

export default Home;


// WEBPACK FOOTER //
// ./src/component/home/home.js